import { createActionCreator } from '../utils/helpers';

import { leads } from './types';

export const requestLeads = createActionCreator(leads.request, 'filter');
export const requestLeadsSuccess = createActionCreator(leads.success, 'data', 'filter');
export const requestLeadsFailure = createActionCreator(leads.failure, 'filter');
